import { PayloadAction } from "@reduxjs/toolkit";
import { Visiable } from "../../../../../common/models/Visiable";
import { ServiceState } from "../models/ServiceState";

const setMessageVisiable = (state: ServiceState, action: PayloadAction<Visiable>) => {
    state.messageVisiable = action.payload.visiable;
}

export default setMessageVisiable;